<div class="error-container">
  <div>
    <p class="numerror">404</p>
    <p class="titulo-error">Página no encontrada</p>
    <p class="texto-error">
      Lo sentimos, parece que la página a la que quiere acceder no se encuentra
      disponible o no existe.
    </p>
    <br />
    <div class="btn-grupo">
      <button
        [routerLink]="['/']"
        class="btn-general"
        style="margin-left: -20px; margin-top: 30px"
      >
        <span>Volver a inicio</span>
      </button>
    </div>
  </div>
</div>
